var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaveight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6247 0.539746H3.10924C2.79234 0.539746 2.53389 0.798197 2.53389 1.1151V19.8827C2.53389 20.1996 2.79234 20.458 3.10924 20.458H5.67289C5.98979 20.458 6.24824 20.1996 6.24824 19.8827C6.24824 19.5658 5.98979 19.3073 5.67289 19.3073H3.68459V1.69045H19.0493V19.3073H17.061C16.7441 19.3073 16.4857 19.5658 16.4857 19.8827C16.4857 20.1996 16.7441 20.458 17.061 20.458H19.6247C19.9416 20.458 20.2 20.1996 20.2 19.8827V1.1151C20.2 0.798197 19.9416 0.539746 19.6247 0.539746Z",
    fill: "#2DA6F4",
    stroke: "#2DA6F4",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2259 12.9792C13.4047 13.1112 11.6959 12.058 11.6767 12.049C11.5707 11.983 11.4293 11.983 11.3233 12.049C11.3041 12.058 9.59208 13.1112 7.77409 12.9792C7.63276 12.9702 7.50107 13.0452 7.44968 13.1682C7.40471 13.2732 6.40899 15.7126 7.53319 17.99C8.21092 19.3642 9.50856 20.3724 11.394 20.9815C11.4293 20.9935 11.4647 20.9995 11.5 20.9995C11.5353 20.9995 11.5707 20.9935 11.606 20.9815C13.4914 20.3724 14.7891 19.3642 15.4668 17.99C16.591 15.7126 15.5953 13.2732 15.5503 13.1682C15.4989 13.0452 15.3672 12.9702 15.2259 12.9792ZM13.6681 15.4966L11.4197 17.897C11.3587 17.963 11.2687 17.999 11.1788 17.999C11.1113 17.999 11.0439 17.978 10.9861 17.939L9.70128 17.0389C9.55996 16.9398 9.53105 16.7508 9.63704 16.6188C9.74304 16.4868 9.9454 16.4598 10.0867 16.5588L11.1338 17.2909L13.1863 15.1005C13.3019 14.9745 13.5043 14.9625 13.6392 15.0735C13.7709 15.1815 13.7869 15.3706 13.6681 15.4966Z",
    fill: "#2DA6F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73668 10.5978H16.9972C17.2589 10.5978 17.4726 10.3841 17.4726 10.1224C17.4726 9.86075 17.2589 9.64707 16.9972 9.64707H5.73668C5.47501 9.64707 5.26133 9.86075 5.26133 10.1224C5.26133 10.3841 5.47501 10.5978 5.73668 10.5978Z",
    fill: "#2DA6F4",
    stroke: "#2DA6F4",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73668 8.38293H16.9972C17.2589 8.38293 17.4726 8.16925 17.4726 7.90758C17.4726 7.64591 17.2589 7.43223 16.9972 7.43223H5.73668C5.47501 7.43223 5.26133 7.64591 5.26133 7.90758C5.26133 8.16925 5.47501 8.38293 5.73668 8.38293Z",
    fill: "#2DA6F4",
    stroke: "#2DA6F4",
    strokeWidth: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73668 6.16809H16.9972C17.2589 6.16809 17.4726 5.95441 17.4726 5.69273C17.4726 5.43106 17.2589 5.21738 16.9972 5.21738H5.73668C5.47501 5.21738 5.26133 5.43106 5.26133 5.69273C5.26133 5.95441 5.47501 6.16809 5.73668 6.16809Z",
    fill: "#2DA6F4",
    stroke: "#2DA6F4",
    strokeWidth: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73668 3.95617H16.9972C17.2589 3.95617 17.4726 3.74249 17.4726 3.48082C17.4726 3.21915 17.2589 3.00547 16.9972 3.00547H5.73668C5.47501 3.00547 5.26133 3.21915 5.26133 3.48082C5.26133 3.74249 5.47501 3.95617 5.73668 3.95617Z",
    fill: "#2DA6F4",
    stroke: "#2DA6F4",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaveight);
export default __webpack_public_path__ + "static/media/naveight.a9e71e0b91082a508a8ba9abf60c1b5a.svg";
export { ForwardRef as ReactComponent };